<agr-page-sidesheet
  [pageTitle]="title | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="cloud_upload"
  [primaryActionText]="'import' | translate"
  (primaryAction)="importTotalNitrogenLegalNorms()"
>
  <app-year-filter
    sidesheet
    [filter]="totalNitrogenLegalNormFilter$ | async"
    (update)="updateFilter($event)"
    (filterEnabled)="setFilterEnabled($event)"
    (filterReset)="resetFilter()"
    [cropEnabled]="true"
  >
  </app-year-filter>

  <ng-container actions>
    @if (isMobile$ | async) {
      <button mat-icon-button (click)="setSearch()" data-test="crop-variety-filter">
        <mat-icon>search</mat-icon>
      </button>
    }
  </ng-container>

  <div class="mat-button-row" actions>
    <button mat-button actionIcon="add" (click)="addNorm()" data-test="add-total-nitrogen-legal-norm">
      <mat-icon>add</mat-icon>
      {{ 'add' | translate }}
    </button>
  </div>
  <agr-notification-empty
    [isEmpty]="!(norms$ | async)?.length"
    [emptyTitle]="'normsEmpty' | translate"
    [emptyDescription]="((filterEnabled$ | async) ? 'noNormsFound' : 'noNorms') | translate"
    emptyActionIcon="clear"
    [emptyActionText]="'resetFilter' | translate"
    [showEmptyAction]="filterEnabled$ | async"
    (emptyAction)="resetFilter()"
  >
    <div class="container">
      <agr-table [config]="tableConfig" data-test="crop-variety-specific-norms-table"></agr-table>
      <mat-paginator
        #paginator
        [pageSize]="defaultPageSize"
        [pageSizeOptions]="pageSizeOptions"
        [length]="totalNumberOfItems$ | async"
        (page)="onPage($event)"
      ></mat-paginator>
    </div>
  </agr-notification-empty>
</agr-page-sidesheet>
